export default __webpack_public_path__ + "img/EESTEC.3cb42746.png";